const getType = (respondentIdType) => {
  switch (respondentIdType) {
    case "ulagos_email_alumno":
    case "email":
      return "correo electrónico";
    default:
      return respondentIdType;
  }
};

export const IDENTIFICATION_MODAL_ERRORS = {
  CREDENTIALS_NOT_VALID: (respondentIdType) => {
    return {
      type: "CREDENTIALS_NOT_VALID",
      message: `El ${getType(respondentIdType)} o la contraseña no son válidos.`,
    };
  },
  NO_USER_FOUND: (respondentIdType) => {
    return {
      type: "NO_USER_FOUND",
      message: `El ${getType(respondentIdType)} ingresado no fue encontrado en el registro.`,
    };
  },
  SURVEY_ALREADY_COMPLETED: () => {
    return {
      type: "SURVEY_ALREADY_COMPLETED",
      message: "Según nuestros registros usted ya respondió la encuesta.",
    };
  },
};
